import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules"
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const Slider = (element: HTMLElement) =>
	new Swiper(element, {
		modules: [Navigation, Pagination],
		spaceBetween: 48,
		slidesPerView: 1,
		breakpoints: {
			900: {
				slidesPerView: 3,
			}
		},
		centerInsufficientSlides: true,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pagination",
		},
	});

export default () => {
	const relatedContentSliders: HTMLElement[] = Array.from(
		document.querySelectorAll(".block.related .slider")
	);

	if (!relatedContentSliders) return;

	relatedContentSliders.map((element: HTMLElement) => Slider(element));
};
